<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/3 sm:w-1/2 mb-base" v-for="project in projects" :key="project.id">
        <div @click="_setType(project.id)">
          <vx-card class="text-center cursor-pointer">
            <img :src="require('@/assets/images/pages/graphic-1.png')" width="180" class="mx-auto mb-4">
            <h4 class="mb-2">{{ project.name }}</h4>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from 'API';

  export default {
    data() {
      return {
        projects: []
      }
    },
    created() {
      this._getProjectTypes();
    },
    methods: {
      _getProjectTypes() {
        API.projects.getTypes()
          .then(({data}) => {
            this.projects = data;
          });
      },

      _setType(typeId) {
        const req = {
          project_id: this.$route.params.id,
          project_type_id: typeId
        }

        API.projects.setType(req)
          .then(({data}) => {
            this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Выбор типа проекта',
              text: 'Успешно выбран тип'
            });

            this.$router.push(`/projects/${data.id}/edit/type-${typeId}`);
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  small {
    color: #999;
  }
</style>
